import { render, staticRenderFns } from "./FullPageMessage.vue?vue&type=template&id=27f161fb&scoped=true"
import script from "./FullPageMessage.vue?vue&type=script&lang=js"
export * from "./FullPageMessage.vue?vue&type=script&lang=js"
import style0 from "./FullPageMessage.vue?vue&type=style&index=0&id=27f161fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f161fb",
  null
  
)

export default component.exports